import './_table.scss';
import React, { useState } from 'react';
import { Table, Button } from 'react-bootstrap';
import PropTypes from 'prop-types';

import Spinner from '../../../../../components/Loaders/Spinner';

import { generateTableHead, makeTableRow } from '../../helpers';
import { API_HOST } from '../../../../../utils/config';
import instance from '../../../../../services/request';

const ExportTable = ({ items, access }) => {
  const [isLoading, setIsLoading] = useState([]);
  const onClickDownload = async (id) => {
    const itemLink = `${API_HOST}/users/export-download/${id}`;
    setIsLoading((prevState) => [...prevState, id]);
    try {
      const response = await instance.get(itemLink, { responseType: 'blob' });
      const filename = response?.headers?.['x-export-file-name'] || `users_export_${+new Date()}.csv`;
      const url = URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading((prevState) => prevState.filter((s) => s !== id));
    }
  };

  return (
    <Table className="export-table">
      <thead>
        <tr>
          {generateTableHead(access?.export_download).map((el, index) => (
            <th className={index === 0 ? 'p-l' : ''} key={index}>
              {el}
            </th>
          ))}
        </tr>
      </thead>

      <tbody>
        {items.map((item, index) => (
          <tr key={index}>
            {makeTableRow(item).map((el, index) => {
              // const link = `${API_HOST}/users/export-download/${el}`;

              if (index === 5) {
                if (!access?.export_download) {
                  return null;
                }

                return (
                  <td className="export-download-button p-r" key={index}>
                    {item.ready ? (
                      <Button onClick={() => onClickDownload(el)} bsSize="xs" class="d-flex" disabled={isLoading?.includes(el)}>
                        {isLoading?.includes(el) && <Spinner />}
                        <span>Download</span>
                      </Button>
                    ) : (
                      <span>{item.export_status_name}</span>
                    )}
                  </td>
                );
              }

              return (
                <td className={index === 0 ? 'p-l' : ''} key={index}>
                  {el}
                </td>
              );
            })}
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

ExportTable.propTypes = {
  items: PropTypes.array,
  access: PropTypes.object,
};

export default ExportTable;
